// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723606710849/%E6%88%B7%E5%A4%96%E9%9C%B2%E8%90%A5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723607105618/%E6%88%B7%E5%A4%96%E9%9C%B2%E8%90%A5.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1727142581088/outdoor_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1727142580539/outdoor_m.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725154456498/euPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725154631105/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725161235678/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725161235852/ukH2.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    nl: imgAllA.EU,
};
export default imgLocale1;
